const copyTextFallback = (text: string): boolean => {
  const ta = document.createElement("textarea");
  ta.value = text;
  ta.setAttribute("readonly", "");
  ta.style.position = "fixed";
  ta.style.opacity = "0";
  ta.style.pointerEvents = "none";
  document.body.appendChild(ta);
  ta.select();
  const ok = document.execCommand("copy");
  ta.remove();
  return ok;
};

(() => {
  const copyBtn = document.getElementById(
    "guide-summary-copy"
  ) as HTMLButtonElement | null;
  const sourceEl = document.getElementById("guide-summary-copy-source");
  if (!copyBtn || !sourceEl) return;

  let resetTimer: ReturnType<typeof setTimeout> | null = null;
  const setLabel = (label: string) => {
    copyBtn.textContent = label;
    if (resetTimer) clearTimeout(resetTimer);
    resetTimer = setTimeout(() => {
      copyBtn.textContent = "Copy";
      resetTimer = null;
    }, 1400);
  };

  copyBtn.addEventListener("click", async () => {
    const text = sourceEl.textContent?.trim() ?? "";
    if (!text) return;

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
        setLabel("Copied");
        return;
      }
    } catch {}

    setLabel(copyTextFallback(text) ? "Copied" : "Failed");
  });
})();
